import { ChangeDetectionStrategy, Component, computed, ViewEncapsulation } from '@angular/core';
import { PlycaUiTreeComponent } from '../tree.component';
import { TreeHeaders } from './_config/tree-demo.model';
import { TreeDemoData, TreeDemoEnum, TreeHeader } from './_config/tree-demo.const';
import { TreeNode } from 'primeng/api';
import { PlycaUiButtonGenericComponent } from '../../../../atoms/buttons/button-generic/button-generic.component';

@Component({
  selector: 'plyca-ui-tree-demo',
  templateUrl: './tree-demo.component.html',
  styleUrls: ['./tree-demo.component.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PlycaUiTreeComponent, PlycaUiButtonGenericComponent]
})
export class PlycaUiTreeDemoComponent {
  public treeHeader: TreeHeaders[] = TreeHeader;
  public treeDemoEnum = TreeDemoEnum;

  protected treeDataSig = computed(() => TreeDemoData);

  public onClickButton(mode: string, event?: TreeNode): void {
    console.error(mode, event);
  }

  public onNodeExpand(event: TreeNode): void {
    console.error(event);
  }
}
